import {BlockType} from "../../model/markdown/MarkdownText"
import {ParsedBlock} from "./blockParseService"

class TableParserService {
    isTableLine(line: string, offset: number): boolean {
        for (let i = offset; i < line.length; i++) {
            if (line[i] === '|') {
                return true
            }
            if (line[i] > ' ') {
                return false
            }
        }
        return false
    }

    isSeparatorRow(cells: string[]): boolean {
        return cells.every(cell => /^:?-+:?$/.test(cell.trim()))
    }

    splitRowCells(rowContent: string): string[] {
        const trimmed = rowContent.trim()
        let content = trimmed
        if (content.startsWith('|')) {
            content = content.substring(1)
        }
        if (content.endsWith('|')) {
            content = content.substring(0, content.length - 1)
        }
        return content.split('|').map(cell => cell.trim())
    }

    getTable(line: string, offset: number, lines: string[], lineNo: number): ParsedBlock {
        const rows: ParsedBlock[] = []
        let lineSkipped = 0

        const headerRow = this.splitRowCells(line.substring(offset))
        rows.push({
            type: BlockType.TABLE,
            content: headerRow.join(' | '),
            offset: 0,
            lineSkipped: 0,
            startFrom: 1,
            hint: 'header',
            indent: 0,
            subBlocks: headerRow.map((cell, idx) => ({
                type: BlockType.TABLE,
                content: cell,
                offset: idx,
                lineSkipped: 0,
                startFrom: 1,
                hint: '',
                indent: 0,
                subBlocks: [],
            })),
        })

        if (lineNo + 1 < lines.length) {
            const sepLine = lines[lineNo + 1]
            const sepCells = this.splitRowCells(sepLine)
            if (this.isSeparatorRow(sepCells)) {
                rows.push({
                    type: BlockType.TABLE,
                    content: sepLine.trim(),
                    offset: 0,
                    lineSkipped: 0,
                    startFrom: 1,
                    hint: 'separator',
                    indent: 0,
                    subBlocks: sepCells.map((cell, idx) => ({
                        type: BlockType.TABLE,
                        content: cell,
                        offset: idx,
                        lineSkipped: 0,
                        startFrom: 1,
                        hint: '',
                        indent: 0,
                        subBlocks: [],
                    })),
                })
                lineSkipped++
            }
        }

        let dataLineNo = lineNo + 1 + lineSkipped
        while (dataLineNo < lines.length) {
            const dataLine = lines[dataLineNo]
            const trimmed = dataLine.trim()

            let isTableRow = false
            for (let i = 0; i < trimmed.length; i++) {
                if (trimmed[i] === '|') { isTableRow = true; break }
                if (trimmed[i] > ' ') break
            }

            if (!isTableRow) {
                break
            }

            const dataCells = this.splitRowCells(dataLine)
            rows.push({
                type: BlockType.TABLE,
                content: dataCells.join(' | '),
                offset: 0,
                lineSkipped: 0,
                startFrom: 1,
                hint: 'data',
                indent: 0,
                subBlocks: dataCells.map((cell, idx) => ({
                    type: BlockType.TABLE,
                    content: cell,
                    offset: idx,
                    lineSkipped: 0,
                    startFrom: 1,
                    hint: '',
                    indent: 0,
                    subBlocks: [],
                })),
            })
            lineSkipped++
            dataLineNo++
        }

        return {
            type: BlockType.TABLE,
            content: line.substring(offset),
            offset,
            lineSkipped,
            startFrom: 1,
            hint: '',
            indent: 0,
            subBlocks: rows,
        }
    }
}

export const tableParserService = new TableParserService()
